// Tabs layout of section-sidebar. Every panel is already in the page, so a tab only toggles
// visibility. The active tab is mirrored in the URL hash (/pages/customer-care#payment), so a
// link can open a given tab. A custom element rather than an inline script, so it also runs
// where the markup is injected (theme editor).
class SectionSidebarTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.section-sidebar__tab'));
    this.panels = Array.from(this.querySelectorAll('.section-sidebar__panel'));
    if (!this.tabs.length) return;

    this.onClick = (event) => {
      const tab = event.target.closest('.section-sidebar__tab');
      if (!tab) return;
      this.select(this.tabs.indexOf(tab));
      // replaceState: a plain hash assignment would scroll to the panel and pile up history entries
      history.replaceState(null, '', '#' + tab.dataset.tabAnchor);
    };
    this.onKeydown = (event) => {
      const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
      const current = this.tabs.indexOf(event.target.closest('.section-sidebar__tab'));
      if (!step || current < 0) return;
      event.preventDefault();
      const next = (current + step + this.tabs.length) % this.tabs.length;
      this.tabs[next].focus();
      this.tabs[next].click();
    };
    this.onHashChange = () => this.selectByHash();

    this.addEventListener('click', this.onClick);
    this.addEventListener('keydown', this.onKeydown);
    window.addEventListener('hashchange', this.onHashChange);
    this.selectByHash();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.removeEventListener('keydown', this.onKeydown);
    window.removeEventListener('hashchange', this.onHashChange);
  }

  selectByHash() {
    const anchor = decodeURIComponent(location.hash.slice(1));
    const index = this.tabs.findIndex((tab) => tab.dataset.tabAnchor === anchor);
    if (index >= 0) this.select(index);
  }

  select(index) {
    if (index < 0) return;
    this.tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected', i === index);
      tab.tabIndex = i === index ? 0 : -1;
    });
    this.panels.forEach((panel, i) => panel.toggleAttribute('hidden', i !== index));
    // On a phone the bar scrolls sideways: keep the chosen tab in view
    this.tabs[index].scrollIntoView({ block: 'nearest', inline: 'nearest' });
  }
}

if (!customElements.get('section-sidebar-tabs')) {
  customElements.define('section-sidebar-tabs', SectionSidebarTabs);
}
